import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

interface StyleProps {
    featured: boolean
}

export const useStylesChip = makeStyles((theme: Theme) => ({
    chip: {
        margin: 1,
        background: theme.colors.black,
        display: 'inline-block',
        padding: '2px 6px',
    },
    chipText: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        margin: 0,
        fontSize: 10,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
    },
}))

export default makeStyles((theme: Theme) => ({
    container: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.5)',
        borderRadius: 8,
        height: '60vw',
        width: '60vw',
        backgroundImage: `linear-gradient(to bottom, rgba(14, 17, 23, 0.32), rgba(14, 17, 23, 0) 17%, rgba(14, 17, 23, 0.4) 51%, rgba(14, 17, 23, 0.8))`,
        '@media (min-width: 461px)': {
            maxWidth: '28vw',
            maxHeight: '28vw',
        },
        '@media (min-width: 1441px)': {
            maxWidth: 368,
            maxHeight: 368,
        },
    },
    featured: {
        width: 640,
        maxWidth: 640,
        minWidth: 640,
        height: 640,
        maxHeight: 640,
        minHeight: 640,
        backgroundImage: 'none',
        '@media (max-width: 1024px)': {
            width: '45vw',
            maxWidth: '45vw',
            minWidth: '45vw',
            minHeight: '45vw',
            maxHeight: '45vw',
        },
        '@media (max-width: 767px)': {
            backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 43%, rgba(0, 0, 0, 0.7) 76%, rgba(0, 0, 0, 0.9) 91%)`,
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            minWidth: '100%',
            minHeight: '100%',
            maxHeight: '100%',
        },
    },
    image: {
        '& > img': {
            objectFit: 'cover',
        },
        zIndex: -1,
        borderRadius: 8,
    },
    status: {
        position: 'absolute',
        margin: 16,
    },
    time: {
        zIndex: 1,
        width: 51,
        height: 50,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.white,
        borderRadius: 2,
        '& > *': {
            fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        },
    },
    month: {
        color: theme.colors.light.darkgrey,
        fontSize: 12,
        marginBottom: 0,
        textTransform: 'uppercase',
    },
    day: {
        height: 24,
        color: theme.colors.black,
        fontWeight: 'bold',
        fontSize: 20,
        marginBottom: 0,
    },
    live: {
        width: 59,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    liveDot: {
        backgroundColor: 'rgba(202, 42, 42, 0.5)',
        position: 'relative',
        borderRadius: 50,
        width: 16,
        height: 16,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& > *': {
            width: 9.1,
            height: 9.1,
            borderRadius: 50,
            backgroundColor: theme.colors.red,
        },
    },
    liveText: {
        margin: 0,
        fontWeight: 'bold',
        fontSize: 16,
    },
    info: {
        bottom: 0,
        margin: '16px 0',
        maxWidth: '60vw',
        '@media (min-width: 768px)': {
            maxWidth: '24vw',
            position: 'absolute',
            margin: 16,
        },
        '@media (min-width: 1441px)': {
            maxWidth: 350,
        },
    },
    title: {
        lineClamp: 2,
        overflow: 'hidden',
        display: 'box',
        boxOrient: 'vertical',
        fontSize: 14,
        color: theme.fontColors.light.color,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        '@media (min-width: 768px)': {
            fontSize: 20,
        },
    },
    subtitle: {
        fontSize: 12,
        opacity: 0.8,
        fontStyle: 'normal',
        color: theme.fontColors.light.color,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        '@media (min-width: 768px)': {
            fontSize: 14,
        },
    },
    bottomCard: {
        '@media(max-width: 767px)': {
            display: 'none',
        },
    },
    bottom: {
        '@media(min-width: 768px)': {
            display: 'none',
        },
    },
}))
